const setPermissions = (state, permissions) => {
  Object.assign(state, permissions)
}
export default {
  setPermissions
}
